import * as React from 'react';
import { ImageField, Show, SimpleShowLayout, TextField } from 'react-admin';

export const ShowProfile = (props) => {
  return (
    <Show
      {...props}
      title={'My Profile'}
      basePath="/my-profile"
      resource="profile"
    >
      <SimpleShowLayout>
        <ImageField source="avatarUrl" />
        <TextField source="name" />
        <TextField source="userId" label="id" />
        <TextField source="role" />
        <TextField source="type" />
        <TextField source="languages" />
      </SimpleShowLayout>
    </Show>
  );
};
